import { Check } from "lucide-react";

export function ProgressBar({ steps, currentStep, selection, onStepClick }) {
  const totalSteps = steps.length;
  const status = (i) => selection[steps[i]?.id] ? "done" : i === currentStep ? "active" : "pending";
  const canNav = (i) => {
    if (i <= currentStep) return true;
    for (let j = 0; j < i; j++) if (!selection[steps[j]?.id]) return false;
    return true;
  };

  return (
    <div className="relative" data-testid="progress-bar">
      <div className="lg:hidden">
        <div className="flex items-center justify-between mb-4">
          <span className="text-sm text-[#888]">Etape {currentStep + 1} sur {totalSteps}</span>
          <span className="text-sm text-[#39FF14]">{steps[currentStep]?.label}</span>
        </div>
        <div className="h-2 bg-[#1A3A1A] rounded-full overflow-hidden">
          <div className="h-full bg-[#39FF14] progress-animate" style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}></div>
        </div>
      </div>
      <div className="hidden lg:flex items-center justify-between">
        {steps.map((step, i) => {
          const s = status(i);
          const cn = canNav(i);
          return (
            <div key={step.id} className="flex items-center flex-1">
              <button
                onClick={() => cn && onStepClick(i)}
                disabled={!cn}
                className={`relative flex flex-col items-center ${cn ? "cursor-pointer" : "cursor-not-allowed"}`}
                data-testid={`step-${step.id}`}
              >
                <div className={`step-bubble ${s}`}>
                  {s === "done" ? <Check className="w-5 h-5" /> : <span>{i + 1}</span>}
                </div>
                <span className={`mt-2 text-xs font-medium whitespace-nowrap ${s === "active" ? "text-[#39FF14]" : s === "done" ? "text-white" : "text-[#888]"}`}>
                  {step.label}
                </span>
              </button>
              {i < steps.length - 1 && (
                <div className={`flex-1 h-0.5 mx-4 ${status(i) === "done" ? "bg-[#39FF14]" : "bg-[#1A3A1A]"}`}></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
